import styled from 'styled-components';

export default styled.div`
    text-align: center;
    margin: var(--spacing-8) 0;
`;
